<template>
    <div>
      <OldLayout v-if="layout==='default'" ></OldLayout>
        <new-layout v-else ></new-layout>
    </div>
</template>
<script>
import OldLayout from './layout.vue'
import NewLayout from './NewLayout.vue'
import {mapGetters} from 'vuex'
export default {

    components:{
        OldLayout,
        NewLayout
    },


    computed:{
        ...mapGetters({
            LayoutType:'Common/NewLayout'
        }),

        layout() {
            return this.$route.meta.layout || 'default';
        },
        ...mapGetters("auth", ["user"]),
        ...mapGetters({
            showroomId: 'Common/MyItem',
        })
    },
    beforeCreate(){
        $('body').removeClass();
        $('body').addClass('default_color_set');
    },
    watch: { 
        user: {
            handler: function (newValue) {
                if (newValue) {
                    if( this.user.type=='Contractor' && ((this.user.custom_addon && this.user.custom_addon.subscription_status) || (this.user.latest_subscription && this.user.latest_subscription.subscription_status && this.user.latest_subscription.plan=='Premium' && this.user.latest_subscription.paid_amount==199)) && this.user.shop_profile && this.user.shop_profile.theme_color){
                        $('body').addClass(this.user.shop_profile.theme_color);
                        $("#logo").attr("src",this.set_image(this.user.shop_profile.business_logo));
                    }else{
                        $('body').removeClass();
                        $('body').addClass('default_color_set');
                        $("#logo").attr("src",this.set_image('assets/images/new-logo.svg'));
                    }
                }
            },
            deep: true,
            immediate:true
        },
        showroomId:{
            handler: function (newValue) {
                if(this.showroomId.custom_addon == true|| this.showroomId.custom_addon== 'true'){
                    $('body').addClass(this.showroomId.theme_color);
                }else{
                    $('body').removeClass();
                    $('body').addClass('default_color_set');
                }
            },
            deep: true,
            immediate:true
        }
    }

}
</script>

